import { defaultCountDesc, defaultCountQty } from './count-defaults';
import { Component, OnInit, HostListener, ViewChild, Inject } from '@angular/core';
import { priceValidator, roundPriceControl, PRICE_MAX_LABEL } from '../validators/price.validator';
import { FormBuilder, FormGroup, FormControl, Validators, FormArray } from "@angular/forms";
import { ProductsService, PRODUCT_IMAGE_WRONG_TYPE, splitProductImageFiles } from '@app/services/products/product.service';
import { ICategory } from '@app/models/category.interface';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CheckboxListComponent } from '@app/modules/products/components/checkbox-list/checkbox-list.component';
import { IProduct } from '@app/models/product.interface';
import { IArea } from '@app/models/area.interface';
import { IBarcode } from '@app/models/barcode.interface';
import { Observable, Subscription } from 'rxjs';
import { MasterCountCategoryService } from '@app/services/master-count-category/master-count-category.service';
import { filter, first, skipWhile, tap } from 'rxjs/operators';
import { Actions, ofType } from '@ngrx/effects';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { FormComponent } from '@app/modules/organization/categories-table/form/form.component';
import { BarcodeLookupDialogComponent } from '../components/barcode-lookup-dialog/barcode-lookup-dialog.component';
import { ConfirmMessageModalComponent } from '@app/shared/components/confirm-message-modal/confirm-message-modal.component';
import { Store, select } from '@ngrx/store';
import { selectSettingsState } from '@app/modules/settings/store/selectors/settings.selectors';
import { selectOrganizationState } from '@app/modules/organization/store/selectors/organization.selectors';
import { SubSink } from 'subsink';
import * as ProductsActions from '@app/modules/products/store/actions/products.actions';
import { AddExistingProductDialogComponent } from '@app/modules/products/components/add-existing-product-dialog/add-existing-product-dialog.component';
import * as OrganizationActions from '@app/modules/organization/store/actions/organization.actions';
import { MatChipInputEvent, MatChipList } from '@angular/material/chips';
import { BreakpointService } from '@app/services/breakpoint/breakpoint.service';
import { LimitAccessService } from '@app/core/services/limit-access.service';
import { selectCoreState, selectMeState } from '@app/core/store/core.selectors';
import * as CoreActions from '@app/core/store/core.action';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { lang_selected$ } from '@app/shared/components/language-selector/language-selector.component';
import { TreeItemFlatNode } from '@app/models/storage.interface';
import { ProductStorageTreeviewComponent } from '@app/shared/components/product-storage-treeview/product-storage-treeview.component';
import { ISerialPatterns } from '@app/models/serialpatterns.interface';
import { ReceivingAddComponent } from '../../receivings/receiving-add/receiving-add.component';
import { loadProducts } from '@app/modules/products/store/actions/products.actions';
import { ProductActivityDialogComponent } from '@app/modules/products/product-activity-dialog/product-activity-dialog.component';
import { QuickReceiveDialogComponent } from '@app/shared/components/quick-receive-dialog/quick-receive-dialog.component';

@Component({
  selector: 'app-product-add',
  templateUrl: './product-add.component.html',
  styleUrls: ['./product-add.component.scss']
})
export class ProductAddComponent implements OnInit{
  roundPrice = roundPriceControl;
  priceMaxLabel = PRICE_MAX_LABEL;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  @ViewChild('matChipList') matChipList: MatChipList; 
  public checkedAreas = [];
  public checkedStorages: TreeItemFlatNode[] = [];
  public duplicateBarcodeMessageDetect = [];
  public duplicateSerialPatternsMessageDetect = [];
  public form: FormGroup;
  public QytLimitData$ : any = 0;
  public categories$: ICategory[];
  public areas$: IArea[];
  public product: IProduct;
  public barcodeSelectedIndex: number = 0;
  public serialPatternsSelectedIndex: number = 0;
  public isAllowedToLeave: boolean = true;
  public isAutoGenPrdCode: boolean = false;
  public subs = new SubSink;
  public settings$;
  public barcodes$: IBarcode[] = [];
  public serialPatterns$: ISerialPatterns[] = [];
  // Per-unit RFID tags staged locally and saved right after product create;
  // the section only renders when the franchise flag is on.
  public rfidValues$: string[] = [];
  // Photo is held here until the product exists, then uploaded — the product
  // has no id to attach it to before that.
  public pendingImageFile: File | null = null;
  public pendingImagePreview: string = '';
  public draggingImage: boolean = false;
  public rfidEnabled$: boolean = false;
  public isBarcodeValid$: boolean = null;
  public isSerialPatternsValid$: boolean = null;
  public isBarcodeSingle$: boolean = null;
  public locPrdCustomFieldLabel1$: string = 'Counting Methods';
  public locPrdCustomFieldLabel2$: string = 'Counting Methods 2';
  public readProductOption: boolean = true;
  public multiBarcodeOption: boolean = false;
  public countingMethodsAddOption: boolean = false;
  public readStorageOption: boolean = false;
  public countingMethodsCountBy: boolean = false;
  public countingMethodsOrderBy: boolean = false;
  public countingMethodsDescriptionOption: boolean = false;
  public countingMethodsQuantityOption: boolean = false;
  public mls1Option: boolean = false;
  public mls2Option: boolean = false;
  public skuError:string = '';
  public barcodeError:string = '';
  public serialPatternsError:string = '';
  width_radio_text = '';
  close_button_margin = '';
  lang_selected: string;
  public subscription: Subscription;
  public show_serialpattern: boolean = false;
  public duplicateprdCodeisSerialized : boolean = false;
  // True when the SKU belongs to a product held elsewhere in the account.
  public skuTakenElsewhere: boolean = false;
  public locUsesAssetModule: number = 0;
  public locUsesSerializedModule: number = 0;

  // Serial UI (checkbox + pattern field) requires the core flag and the location Serialized Module
  get showSerialBlock(): boolean {
    return !!this.show_serialpattern && this.locUsesSerializedModule === 1;
  }

  @ViewChild('chipList') chipList;
  @ViewChild('chipInput') chipInput;
  @ViewChild('chipList1') chipList1;
  @ViewChild('chipInput1') chipInput1;
  @HostListener('window:beforeunload')
  canDeactivate(): Observable<boolean> | boolean {
    return this.isAllowedToLeave;
  }

  constructor(
    private fb: FormBuilder,
    private _products: ProductsService,
    private _matDialog: MatDialog,
    private _master: MasterCountCategoryService,
    private store$: Store,
    @Inject(MAT_DIALOG_DATA) public matDialogData,
    private dialogRef: MatDialogRef<ProductAddComponent>,
    public _translation: TranslateService,
    private _breakpoints:BreakpointService,
    private limitAccessService: LimitAccessService,
    private actions$: Actions,
    private _toastr: ToastrService
  ) {
    this.form = this.fb.group({
      prdNameEn: new FormControl('', [Validators.required]),
      prdSKU: new FormControl(''),
      prdCode: new FormControl('', [Validators.required, Validators.maxLength(18)]),
      prdBrand: new FormControl(''),
      prdPackageUOM: new FormControl(''),
      prdCatID: new FormControl(''),
      prdCountTypeID: new FormControl(1),
      prdCasePack: new FormControl(''),
      selectedAreas: new FormControl([]),
      selectedStorages: new FormControl([]),
      prdCustomField1: new FormControl(null),
      prdIsSerialized: new FormControl(false),
      prdIsAsset: new FormControl(false),
      prdAssetsNumber: new FormControl(''),
      counts: this.fb.array([]),
      barcodes: new FormControl([]),
      serialPatterns: new FormControl([]),
      prdDescription: new FormControl(''),
      // Tag names; the API stores them as "A, B".
      prdTags: new FormControl([]),
      prdCustomField2: new FormControl('')
    });
  }

  ngOnInit(): void {
    this._products.getFranchiseFlags().pipe(first()).subscribe({
      next: (flags) => { this.rfidEnabled$ = flags?.fTypeEnableRfid == 1; },
      error: () => { this.rfidEnabled$ = false; }
    });

    this.subscription = lang_selected$.subscribe(value => {
      this.lang_selected = value;
      if(this.lang_selected != 'en-ca'){
        this.width_radio_text = 'width_radio_text';
        this.close_button_margin = 'close_button_margin';
      }else{
        this.width_radio_text = '';
        this.close_button_margin = '';
      }
    });

    this.getQytLimitData();
    this.limitAccessService.arraySettingAccess$.subscribe((arraySettingAccess) => {
      if (arraySettingAccess) {
        this.readProductOption = this.limitAccessService.getAccess('products', 'products', '','');
        let resultMultiBarcode = this.limitAccessService.getAccess('products', 'products', 'form','multi_barcode');
        let resultCountingMethodsAdd = this.limitAccessService.getAccess('products', 'products', 'form','counting_methods_add');
        let resultCountingMethodsCountBy = this.limitAccessService.getAccess('products', 'products', 'form','counting_methods_count_by');
        let resultCountingMethodsOrderBy = this.limitAccessService.getAccess('products', 'products', 'form','counting_methods_order_by');
        let resultCountingMethodsDescription = this.limitAccessService.getAccess('products', 'products', 'form','counting_methods_description');
        let resultCountingMethodsQuantity = this.limitAccessService.getAccess('products', 'products', 'form','counting_methods_quantity');
        let resultMls1 = this.limitAccessService.getAccess('administration', 'settings', 'catalog_settings','mls1');
        let resultMls2 = this.limitAccessService.getAccess('administration', 'settings', 'catalog_settings','mls2');
        this.readStorageOption = this.limitAccessService.getAccess('products', 'storages', '','');
        this.multiBarcodeOption = resultMultiBarcode;
        this.countingMethodsAddOption = resultCountingMethodsAdd;
        this.countingMethodsCountBy = resultCountingMethodsCountBy;
        this.countingMethodsOrderBy = resultCountingMethodsOrderBy;
        this.countingMethodsDescriptionOption = resultCountingMethodsDescription;
        this.countingMethodsQuantityOption = resultCountingMethodsQuantity;
        this.mls1Option = resultMls1;
        this.mls2Option = resultMls2;
        this.applyCountDefaults();
      }
    });
    this.subs.add(this.store$.select(selectOrganizationState).pipe(
    ).subscribe(({ categories, areas }) => {      
      this.categories$ = categories;
      this.areas$ = areas;
      if(this.areas$!=null){
        this.checkedAreas = this.areas$.filter(item => item.checked == true);
      }
    }));

      this.store$
      .select(selectCoreState)
      .pipe(
        filter((res) => res !== undefined && res !== null), 
        tap((res) => {
          this.show_serialpattern = res.show_serialpattern;
        })
      ).subscribe();

    this.store$.pipe(select(selectSettingsState)).subscribe((settings) => {
      this.settings$ = settings;
      this.locUsesAssetModule = Number(settings.locUsesAssetModule) || 0;
      this.locUsesSerializedModule = Number(settings.locUsesSerializedModule) || 0;

      if(settings.locEnableCustomField1 == 1){
        this.locPrdCustomFieldLabel1$ = this.settings$.locPrdCustomFieldLabel1;
      }

      if(settings.locEnableCustomField2 == 1){
        this.locPrdCustomFieldLabel2$ = this.settings$.locPrdCustomFieldLabel2;
      }
    });

    this._master.onGetCategories();
    this.form.valueChanges.subscribe(() => this.isAllowedToLeave = false);
    this.addCount();

    // Asset toggle değiştiğinde storage seçimini ve Asset Number validasyonunu güncelle
    this.form.get('prdIsAsset')?.valueChanges.subscribe((isAsset: boolean) => {
      if (isAsset) {
        // Asset için sadece ilk storage'ı tut
        if (this.checkedStorages.length > 1) {
          this.checkedStorages = [this.checkedStorages[0]];
        }
        // Asset Number zorunlu yap
        this.form.get('prdAssetsNumber')?.setValidators([Validators.required]);
      } else {
        // Asset Number zorunluluğunu kaldır
        this.form.get('prdAssetsNumber')?.clearValidators();
      }
      this.form.get('prdAssetsNumber')?.updateValueAndValidity();
      this.applyAssetQty();
    });

    // Auto-fill SKU from Asset Number (only if SKU is empty or was auto-filled)
    this.form.get('prdAssetsNumber')?.valueChanges.subscribe((assetNumber: string) => {
      const isAsset = this.form.get('prdIsAsset')?.value;
      const currentSKU = this.form.get('prdCode')?.value || '';

      // Copy if SKU is empty OR if Asset Number starts with current SKU (meaning it was auto-filled)
      if (isAsset && assetNumber && (currentSKU === '' || assetNumber.startsWith(currentSKU))) {
        this.form.get('prdCode')?.setValue(assetNumber, { emitEvent: false });
      }
    });
  }
  

  ngOnDestroy() {
    this.subs.unsubscribe()
    this.form.reset();
    this.store$.dispatch(ProductsActions.resetProduct());
    this.store$.dispatch(OrganizationActions.resetPsa());
    this._products.onSetIsAllowedToLeave(true);
  }

  get counts() {
    return this.form.get("counts") as FormArray;
  }

  addCount() {
    this.counts.push(this.createCount());
    this.form.markAllAsTouched();
  }

  onRemoveCount(i, row) {
    this.counts.removeAt(i);
    if (row.controls.pcmIsDefaultCountMethod.value == "1") {
      this.counts.controls[0].patchValue({
        pcmIsDefaultCountMethod: "1"
      });
    }
  }

  // Entitlements can arrive (and change) after the first row is built. Untouched
  // rows follow them via the shared prefill rule.
  private applyCountDefaults(): void {
    const isAsset = !!this.form.get('prdIsAsset')?.value;
    this.counts.controls.forEach((row: any, index: number) => {
      const desc = row.get('pcmDesc');
      const qty = row.get('pcmItemQty');
      if (desc?.pristine) {
        desc.setValue(defaultCountDesc(this.countingMethodsDescriptionOption, index === 0), { emitEvent: false });
      }
      if (qty?.pristine) {
        qty.setValue(defaultCountQty(this.countingMethodsQuantityOption, isAsset, index === 0), { emitEvent: false });
      }
    });
  }

  // Asset mode takes over the quantity field, so on every toggle (either way) the
  // quantity is reset to the rule's value regardless of what was typed before, and
  // marked pristine again. Restoring an earlier typed value was rejected: it would
  // resurrect a number the user may have forgotten while the field was locked.
  private applyAssetQty(): void {
    const isAsset = !!this.form.get('prdIsAsset')?.value;
    this.counts.controls.forEach((row: any, index: number) => {
      const qty = row.get('pcmItemQty');
      if (qty) {
        qty.setValue(defaultCountQty(this.countingMethodsQuantityOption, isAsset, index === 0), { emitEvent: false });
        qty.markAsPristine();
      }
    });
  }

  createCount(): FormGroup {
    return this.fb.group({
      // Readonly fields keep the default, otherwise the required validator can never pass
      pcmDesc: new FormControl(defaultCountDesc(this.countingMethodsDescriptionOption, this.counts.length === 0), [Validators.required]),
      pcmCost: new FormControl('', [priceValidator()]),
      pcmRetail: new FormControl('', [priceValidator()]),
      pcmMinQty1: new FormControl(''),
      pcmMinQty2: new FormControl({ value: '', disabled: this.settings$?.locEnableMultiMinQty == 0 }),
      pcmIsDefaultCountMethod: new FormControl(this.counts.length > 0 ? 0 : 1, [Validators.required]),
      pcmIsDefaultOrderMethod: new FormControl(this.counts.length > 0 ? 0 : 1, [Validators.required]),
      pcmItemQty: new FormControl(defaultCountQty(this.countingMethodsQuantityOption, !!this.form.get('prdIsAsset')?.value, this.counts.length === 0), [Validators.required]),
    });
  }

  // Product photo, staged locally. The preview is a data url so nothing is
  // uploaded until the product is actually created.
  onImageSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const files = Array.from(input.files || []);
    input.value = '';
    this.stageImageFiles(files);
  }

  onImageDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.draggingImage = true;
  }

  onImageDragLeave(event: DragEvent): void {
    event.preventDefault();
    this.draggingImage = false;
  }

  onImageDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.draggingImage = false;
    this.stageImageFiles(Array.from(event.dataTransfer?.files || []));
  }

  // Shared by the file picker and drag-and-drop (accept does not filter a drop).
  // The product has a single cover here: the first supported file is staged and
  // every unsupported or surplus file is named in a message.
  private stageImageFiles(files: File[]): void {
    const { valid, invalid } = splitProductImageFiles(files);
    if (invalid.length) {
      this._toastr.error(this._translation.instant('products.photoWrongTypeNamed', {
        names: invalid.map((f) => f.name).join(', ')
      }));
    }
    if (valid.length > 1) {
      this._toastr.warning(this._translation.instant('products.photoOnlyOneOnAdd', {
        names: valid.slice(1).map((f) => f.name).join(', ')
      }));
    }
    if (valid.length) { this.stageImage(valid[0]); }
  }

  onRemoveImage(): void {
    this.pendingImageFile = null;
    this.pendingImagePreview = '';
  }

  private stageImage(file: File): void {
    this.pendingImageFile = file;
    const reader = new FileReader();
    reader.onload = () => { this.pendingImagePreview = String(reader.result || ''); };
    reader.readAsDataURL(file);
  }

  async onSubmit() {
    
    if (!this.form.controls['prdIsSerialized'].value) {
      this.form.controls['serialPatterns'].setValue([]);  
    }

    //sku and barcode validate...
    let prdCheck = await this.checkPrdCode();
    let barcodeCheck = await this.checkBarcodes();
    let serialPatternsCheck = await this.checkSerialPatterns();

    if (!prdCheck) {
      return false;
    }
    if (!barcodeCheck) {
      return false;
    }
    if (!serialPatternsCheck) {
      return false;
    }

    // Storage is optional for assets too — like normal products, an asset can be
    // saved without a storage and assigned one later. (Borrowing still requires
    // stock in a storage, which the borrow dialog handles separately.)
    const barcodeValue = (document.getElementById('chipInput') as HTMLInputElement).value; 
    if (barcodeValue.trim() !== '') {
      if(this.QytLimitData$<(this.barcodes$.length+1) && this.QytLimitData$!=0){
        this.store$.dispatch(CoreActions.showErrorMessage({
          title: this._translation.instant('errormessage.warning'),
          body: this._translation.instant('errormessage.limitbarcode'),
          show_upgrade: true
        }));
        return;
      }else{

        

        this.barcodes$.push({
          barcodeData: barcodeValue,
          barcodeID: null,
          barcodePrdID: null,
        }); 
        (document.getElementById('chipInput') as HTMLInputElement).value = ''; 

        this.barcodes$ = this.barcodes$.filter((item, index, array) => {
          return array.findIndex(obj => obj.barcodeData === item.barcodeData) === index;
        });
      }
    }

    if(this.showSerialBlock && this.form.controls['prdIsSerialized'].value){
      const serialPatternsValue = (document.getElementById('chipInput1') as HTMLInputElement).value; 
      if (serialPatternsValue.trim() !== '') {
          this.serialPatterns$.push({
            serialPattern: serialPatternsValue,
            productSerialNumberPatternsID: null,
            prdID: null,
          }); 

          this.serialPatterns$ = this.serialPatterns$.filter((item, index, array) => {
            return array.findIndex(obj => obj.serialPattern === item.serialPattern) === index;
          });

          (document.getElementById('chipInput1') as HTMLInputElement).value = '';       
      }
    }
 
    const selectedAreas = this.areas$?.filter(item => item.checked === true).map(item => item.prdAreaID);
    this.form.patchValue({
      selectedAreas,
      selectedStorages: this.checkedStorages.map(storage => ({ 
        storageStructureID: storage.storageStructureID, 
        path: storage.path,
        name: storage.item
      })),
      barcodes: this.barcodes$,
      serialPatterns: this.serialPatterns$
    });

    this.isAllowedToLeave = true;
    this.store$.dispatch(ProductsActions.saveProduct({ form: this.form.value }))

    if(this.matDialogData?.addFromReceiving!=true){
      this.actions$.pipe(
        ofType(ProductsActions.saveProductSuccess),
        first()
      ).subscribe((response: any) => {
        this._matDialog.closeAll();

        const isAsset = this.form.get('prdIsAsset')?.value;
        const hasStorage = this.checkedStorages.length > 0;

        // Save staged RFID tags right after the product exists. Conflicting
        // values are skipped server-side reporting; failures are non-fatal
        // (tags can still be added from product edit).
        if (this.rfidValues$.length > 0 && response.product?.prdID) {
          this._products.addRfidTags(response.product.prdID, this.rfidValues$)
            .pipe(first()).subscribe({ next: () => {}, error: () => {} });
        }

        // Same idea for the photo: non-fatal, it can still be added from
        // product edit if the upload fails.
        if (this.pendingImageFile && response.product?.prdID) {
          this._products.uploadProductImage(response.product.prdID, this.pendingImageFile)
            .pipe(first()).subscribe({
              next: () => {},
              error: (err: any) => {
                const key = err?.message === PRODUCT_IMAGE_WRONG_TYPE ? 'products.photoWrongType'
                  : err?.status === 413 ? 'products.photoTooLarge' : 'products.photoUploadFailed';
                this._toastr.error(this._translation.instant(key));
              }
            });
        }

        if (!isAsset && hasStorage && response.product?.prdID) {
          this.openProductActivityDialog(response.product.prdID);
        }
      });

      this.actions$.pipe(
        ofType(ProductsActions.saveProductFailure),
        first()
      ).subscribe(() => {
        // Dialog stays open, error is shown via toastr
      });
    }
    else{
      this.dialogRef.close({ prdNameEn: this.form.get('prdNameEn').value });
    }

  }

  private openProductActivityDialog(prdID: number): void {
    this._matDialog.open(ProductActivityDialogComponent, {
      data: {
        prdID: prdID,
        prdNameEn: this.form.get('prdNameEn').value,
        prdCode: this.form.get('prdCode').value,
        locEnablePrinting: this.settings$.locEnablePrinting,
        locEnableBrotherPrinting: this.settings$.locEnableBrotherPrinting,
        locPrdCustomFieldLabel1: this.settings$.locPrdCustomFieldLabel1,
        locPrdCustomFieldLabel2: this.settings$.locPrdCustomFieldLabel2,
        prdCustomField1: this.form.get('prdCustomField1')?.value,
        prdCustomField2: this.form.get('prdCustomField2')?.value,
        customFieldPrintable: this.settings$.customFieldPrintable,
        prdCasePack: this.form.get('prdCasePack')?.value
      },
      minWidth: '60vw',
      maxWidth: '900px',
      maxHeight: '80vh',
      panelClass: 'ProductActivity__Modal'
    });
  }

  onOpenAreas(): void {
    this._matDialog.open(CheckboxListComponent, {
      width: this._breakpoints.isMobile() === true ? "90vw" : "30vw",
      panelClass: 'ProductAdd__AreasModal'
    });
  }

  onRemoveArea(item: IArea) {
    this.store$.dispatch(OrganizationActions.checkArea({ prdAreaID: item.prdAreaID, checked: false }))
  }

  onValidatePrdCode(event) {
    this.checkPrdCode();
  }

  onBarcodeDelete(index) {
    this.barcodes$.splice(index, 1);
      if(Object.keys(this.barcodes$).length <= 1){
        this.isBarcodeSingle$ = true;
      }
  }
  onSerialPatternsDelete(index) {
    this.serialPatterns$.splice(index, 1);
  }

  onSelectBarcode(index) {
    this.barcodes$[this.barcodeSelectedIndex].selected = false;
    this.barcodes$[index].selected = true;
    this.barcodeSelectedIndex = index;
    localStorage.setItem('prdBarcode', this.barcodes$[index].barcodeData);
  }
  onSelectSerialPatterns(index) {
    this.serialPatterns$[this.serialPatternsSelectedIndex].selected = false;
    this.serialPatterns$[index].selected = true;
    this.serialPatternsSelectedIndex = index;
    localStorage.setItem('prdSerialPattern', this.serialPatterns$[index].serialPattern);
  }

  onOpenStorages(): void {
    const isAsset = this.form.get('prdIsAsset')?.value;
    const isMobileStorage = this._breakpoints.isMobile() === true;
    const dialog = this._matDialog.open(ProductStorageTreeviewComponent, {
      width: isMobileStorage ? "100vw" : "30vw",
      // Override Material's default 80vw cap so the picker is truly full-width on phones.
      maxWidth: isMobileStorage ? "100vw" : "80vw",
      data:{
        "storages": this.checkedStorages,
        "singleSelect": isAsset  // Asset için tek seçim
      }
    });

    dialog.afterClosed().subscribe(res => {
      if(res!=undefined && res!='cancel'){
        // Asset için sadece tek storage al
        if (isAsset && res.length > 1) {
          this.checkedStorages = [res[res.length - 1]];
        } else {
          this.checkedStorages = res;
        }
      }
    });
  }
  
  onBarcodeKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter' || event.keyCode === 13) {
      const inputValue = this.chipInput.nativeElement.value.trim();
      if(this.duplicateBarcodeMessageDetect[inputValue] == true)
      {
        delete this.duplicateBarcodeMessageDetect[inputValue];
        return false;
      }
      this.duplicateBarcodeMessageDetect[inputValue] = true;
    }
  }

  onSerialPatternsKeyDown(event: KeyboardEvent) {
    const allowedKeys = /^[A-Za-z0-9-_]*$/;
    const key = event.key;
    
    if (!allowedKeys.test(key) && key !== 'Backspace' && key !== 'Tab' && key !== 'Enter') {
      event.preventDefault(); 
    }
    
    if (event.key === 'Enter' || event.keyCode === 13) {
      const inputValue = this.chipInput1.nativeElement.value.trim();
      if(this.duplicateSerialPatternsMessageDetect[inputValue] == true)
      {
        delete this.duplicateSerialPatternsMessageDetect[inputValue];
        return false;
      }
      this.duplicateSerialPatternsMessageDetect[inputValue] = true;
    }
  }

  onBarcodeKeyUp(event) {
    this.form.controls['barcodes'].setErrors({ required: false });
    this.form.controls['barcodes'].setErrors(null);
    this.isBarcodeValid$ = true;
    this.isBarcodeSingle$ = true;
  }

  /**
   * Open the barcode (UPC/EAN) lookup modal. The user enters a code; on a hit
   * the resolved data is applied to this form (only empty fields are filled, so
   * the user's own input is never overwritten).
   */
  onOpenBarcodeLookup(): void {
    const ref = this._matDialog.open(BarcodeLookupDialogComponent, {
      minWidth: '420px',
      maxWidth: '90vw',
      panelClass: 'BarcodeLookup__Modal'
    });
    ref.afterClosed().pipe(first()).subscribe((res: any) => {
      if (!res) {
        return;
      }
      // If the form already holds product details (a previous lookup or typed
      // values), confirm before clearing them and applying the new product.
      if (this.hasLookupValues()) {
        const confirmRef = this._matDialog.open(ConfirmMessageModalComponent, {
          data: {
            confirmTitle: this._translation.instant('products.lookup.replaceTitle'),
            confirmDescription: this._translation.instant('products.lookup.replaceConfirm')
          },
          minWidth: '380px',
          maxWidth: '90vw'
        });
        confirmRef.afterClosed().pipe(first()).subscribe((ok: any) => {
          if (ok === 'true' || ok === true) {
            this.clearLookupFields();
            this.applyPrefill(res.prefill, res.barcode);
          }
        });
      } else {
        this.applyPrefill(res.prefill, res.barcode);
      }
    });
  }

  // Fields the barcode lookup writes to (used for conflict detection/clearing).
  private lookupFields = ['prdNameEn', 'prdDescription', 'prdBrand', 'prdCasePack', 'prdCode', 'prdCatID'];

  private hasLookupValues(): boolean {
    const anyField = this.lookupFields.some(c => {
      const v = this.form.get(c)?.value;
      return v !== null && v !== undefined && v !== '';
    });
    return anyField || (this.barcodes$ && this.barcodes$.length > 0);
  }

  private clearLookupFields(): void {
    this.lookupFields.forEach(c => this.form.get(c)?.setValue(''));
    this.barcodes$ = [];
    this.form.patchValue({ barcodes: this.barcodes$ });
  }

  private applyPrefill(prefill: any, barcode: any): void {
    const setIfEmpty = (ctrl: string, val: any) => {
      const c = this.form.get(ctrl);
      if (val && c && (c.value === null || c.value === undefined || c.value === '')) {
        c.setValue(val);
      }
    };

    if (barcode) {
      if (!this.barcodes$.some(b => b.barcodeData === String(barcode))) {
        this.barcodes$.push({ barcodeData: String(barcode), barcodeID: null, barcodePrdID: null });
        this.form.patchValue({ barcodes: this.barcodes$ });
      }
      // Copy the barcode into the SKU field too (only if SKU is empty).
      setIfEmpty('prdCode', String(barcode));
    }

    if (prefill) {
      setIfEmpty('prdNameEn', prefill.prdNameEn);
      setIfEmpty('prdDescription', prefill.prdDescription);
      setIfEmpty('prdBrand', prefill.prdBrand);
      setIfEmpty('prdCasePack', prefill.prdCasePack);
      // Only preselect a category that already exists at this location.
      if (prefill.categoryId) {
        this.form.get('prdCatID')?.setValue(prefill.categoryId);
      }
    }
  }

  onSerialPatternsKeyUp(event) {
    this.form.controls['serialPatterns'].setErrors({ required: false });
    this.form.controls['serialPatterns'].setErrors(null);
    this.isSerialPatternsValid$ = true;
  }

  // RFID values are only staged here; uniqueness is validated by the backend
  // when they are saved right after product create.
  onRfidSubmit(event: MatChipInputEvent) {
    const value = (event.value || '').trim().toUpperCase();
    if (value === '') { return; }
    if (!this.rfidValues$.includes(value)) {
      this.rfidValues$.push(value);
    }
    if (event.input) { event.input.value = ''; }
  }

  onRfidDelete(index: number) {
    this.rfidValues$.splice(index, 1);
  }

  async onBarcodeSubmit(event: MatChipInputEvent) {
    // Prevent duplicate barcode message
    if(this.duplicateBarcodeMessageDetect[event.value] == true)
    {
      //delete this.duplicateBarcodeMessageDetect[event.value];
      return false;
    }

    if (event.value.trim() != "") {
      if(this.QytLimitData$>this.chipList.chips.length || this.QytLimitData$==0){
        
        if(this.multiBarcodeOption ==false){
          if(Object.keys(this.barcodes$).length >= 1){
            this.isBarcodeSingle$ = false;
            return;
          }else{
            this.isBarcodeSingle$ = true;
          }
        }
        
        let prdCode = this.form.get('prdCode').value.trim();
        const barcodeValue = this.barcodes$.map(b => b.barcodeData).join(',');
        
        const serialPatternsValue = this.serialPatterns$.map(b => b.serialPattern).join(',');
        this._products.validateProductData('barcode',prdCode, event.value, serialPatternsValue,null).pipe(first()).subscribe(({ error, message }) => {          
          this.isBarcodeValid$ = !error;
          if(this.isBarcodeValid$ == true){
            this.chipInput.nativeElement.value = "";

            this.barcodes$.push({
              barcodeData: event.value,
              barcodeID: null,
              barcodePrdID: null,
            });

            this.barcodes$ = this.barcodes$.filter((item, index, array) => {
              return array.findIndex(obj => obj.barcodeData === item.barcodeData) === index;
            });
          }
          else{
            this.barcodeError = message;
            this.form.controls['barcodes'].setErrors({ valid: false });
          }
        });

      } else{
        this.store$.dispatch(CoreActions.showErrorMessage({
          title: this._translation.instant('errormessage.warning'),
          body: this._translation.instant('errormessage.limitbarcode'),
          show_upgrade: true
        }));
      }
      
    }
  }

  async onSerialPatternsSubmit(event: MatChipInputEvent) {
    if(this.duplicateSerialPatternsMessageDetect[event.value] == true)
    {
      return false;
    }

    if (event.value.trim() != "") {
      let prdCode = this.form.get('prdCode').value.trim();
      const barcodeValue = this.barcodes$.map(b => b.barcodeData).join(',');
      const serialPatternsValue = this.serialPatterns$.map(b => b.serialPattern).join(',');
      this._products.validateProductData('serialPattern',prdCode, barcodeValue, event.value,null).pipe(first()).subscribe(({ error, message }) => {          
        this.isSerialPatternsValid$ = !error;
          if(this.isSerialPatternsValid$ == true){
            this.chipInput1.nativeElement.value = "";

            this.serialPatterns$.push({
              serialPattern: event.value,
              productSerialNumberPatternsID: null,
              prdID: null
            });

            this.serialPatterns$ = this.serialPatterns$.filter((item, index, array) => {
              return array.findIndex(obj => obj.serialPattern === item.serialPattern) === index;
            });
          }
        });
    }
  }

  onAddCategory() {
    const dialogRef = this._matDialog.open(FormComponent, {
      data: {
        type: 'Add',
        area: null
      },
      panelClass:'overflow-hidden',
      width: this._breakpoints.isMobile() === true ? "100vw" : "30vw",
    });

    dialogRef.afterClosed().subscribe(saved => {
      if(saved == true){
        this.form.get('prdCatID').setValue(this.categories$[this.categories$.length - 1].prdCatID);
      }
    });
  }

  onToggleDefault(row, i) {
    this.counts.controls.forEach((item: any, current) => {
      if (current != i) {
        item.patchValue({
          pcmIsDefaultCountMethod: "0"
        })
      }
    });
  }

  onToggleOrder(row, i) {
    this.counts.controls.forEach((item: any, current) => {
      if (current != i) {
        item.patchValue({
          pcmIsDefaultOrderMethod: "0"
        })
      }
    });
  }

  async getQytLimitData(){
    await this.store$.select(selectMeState).pipe(
      skipWhile(res => res == null),
    ).subscribe((data) => {
      this.QytLimitData$ = data.settingQtyLimiter.barcodes;
    });
  }

  onStorageRemove(item: TreeItemFlatNode) {
    this.checkedStorages = this.checkedStorages.filter(storage => storage.storageStructureID !== item.storageStructureID);
  }


  checkPrdCode(): Promise<boolean> {
    if (this.form.controls['prdCode'].hasError('required') || this.form.controls['prdCode'].hasError('maxLength')) {
      return Promise.resolve(false);
    }
  
    return new Promise<boolean>((resolve) => {
      let prdCode = this.form.get('prdCode').value.trim();
      
      if (prdCode === '') {
        this.form.controls['prdCode'].setErrors({ required: true });
        resolve(false);
      } else if (prdCode.length > 18) {
        this.form.controls['prdCode'].setErrors({ maxLength: true });
        resolve(false);
      } else {
        const barcodeValue = this.barcodes$.map(b => b.barcodeData).join(',');
        const serialPatternsValue = this.serialPatterns$.map(b => b.serialPattern).join(',');
        this._products.validateProductData('sku', prdCode, barcodeValue,serialPatternsValue, null).subscribe(({ error, message, data }) => {
          if (error) {
            this.duplicateprdCodeisSerialized = data?.prdIsSerialized;
            // A SKU can be taken by a product that is not at this location at
            // all. Receiving cannot help there - the product has to join the
            // location first - so the form offers that instead.
            this.skuTakenElsewhere = data?.existsAtThisLocation === false;
            this.skuError = this._translation.instant(message);
            this.form.controls['prdCode'].setErrors({ valid: false });
            resolve(false);
          } else {
            this.skuTakenElsewhere = false;
            // Clear only when nothing else is wrong with the field.
            if (!this.form.controls['prdCode'].hasError('maxLength') && !this.form.controls['prdCode'].hasError('required')) {
              this.form.controls['prdCode'].setErrors(null);
            }
            resolve(true);
          }
        });
      }
    });
  }
    
  checkBarcodes(): Promise<boolean> {
    this.form.controls['barcodes'].setErrors(null);

    return new Promise<boolean>((resolve, reject) => {

      //if(this.barcodes$.length == 0 && (document.getElementById('chipInput') as HTMLInputElement).value.trim() == ''){  
      //  this.form.controls['barcodes'].setErrors({ required: true });
      //  resolve(false);
      //}
      let prdCode = this.form.get('prdCode').value.trim();
      const barcodeValue = (document.getElementById('chipInput') as HTMLInputElement)?(document.getElementById('chipInput') as HTMLInputElement).value:"";
      const serialPatternsValue = this.serialPatterns$.map(b => b.serialPattern).join(',');
      this._products.validateProductData('barcode',prdCode, barcodeValue, serialPatternsValue, null).pipe(first()).subscribe(({ error, message }) => {
        if (error) {
          this.isBarcodeValid$ = false;
          this.barcodeError = this._translation.instant(message);
          this.form.controls['barcodes'].setErrors({ valid: false });
          resolve(false);
        } else {
          this.barcodeError = '';
          resolve(true);
        }
      });
    });
  }

  checkSerialPatterns(): Promise<boolean> {
    this.form.controls['serialPatterns'].setErrors(null);

    return new Promise<boolean>((resolve, reject) => {

      let prdCode = this.form.get('prdCode').value.trim();
      const barcodeValue = this.barcodes$.map(b => b.barcodeData).join(',');
      const serialPatternsValue = this.form.controls['prdIsSerialized'].value ? ((document.getElementById('chipInput1') as HTMLInputElement)?(document.getElementById('chipInput1') as HTMLInputElement).value:"") : "";
      this._products.validateProductData('serialPattern', prdCode,barcodeValue,  serialPatternsValue, null).pipe(first()).subscribe(({ error, message }) => {
        if (error) {
          this.form.controls['serialPatterns'].setErrors({ valid: false });
          resolve(false);
        } else {
          resolve(true);
        }
      });
    });
  }

  // The SKU exists in the catalog but not at this location: send the user to
  // the flow that brings an existing product in, rather than to Receiving,
  // which can only act on products that are already here.
  addExistingProductToLocation() {
    this._matDialog.closeAll();
    const dialog = this._matDialog.open(AddExistingProductDialogComponent, {
      width: '800px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      data: { prefillSearch: this.form.get('prdCode')?.value?.trim() || '' }
    });

    dialog.afterClosed().pipe(first()).subscribe((res: any) => {
      if (res?.added) {
        this.store$.dispatch(ProductsActions.loadProducts({ query: '' }));
      }
    });
  }

  async receivingProduct() {
    const limit_status = 1; //await this._userLimitService.onGetUserLimitStatus('receivings');
      if(limit_status){

        if(this.duplicateprdCodeisSerialized){
          this.store$.dispatch(CoreActions.showErrorMessage({
            title: this._translation.instant('errormessage.warning'),
            body: this._translation.instant('product.serialized.receive.error.message'),
            show_upgrade: false
          }));
        }
        else{
          this._matDialog.closeAll();
          const dialogRef = this._matDialog.open(ReceivingAddComponent, {
              minWidth: '40vw',
              minHeight: '400px',
              maxWidth: '',
              maxHeight: '80vh',
              panelClass: 'ReceivingAdd__Modal',
              data: {
                prdCode: this.form.get('prdCode').value.trim(),
                prdNameEn: this.form.get('prdNameEn').value.trim(),
                action:'product_receiving',
              }
            });

            dialogRef.afterClosed().subscribe(result => {
              this.store$.dispatch(loadProducts({query:''}));
            });
        }

      }else{
        this.store$.dispatch(CoreActions.showErrorMessage({
          title: this._translation.instant('errormessage.warning'),
          body: this._translation.instant('errormessage.limitreceiving'),
          show_upgrade: true
        }));
      }
}


}
